/** Helpers de módulos contratables (sesión). */
import { getModulos as getStoredModulos } from '@/utils/session';

export function getModulos() {
    return getStoredModulos();
}

export function hasFeature(feature) {
    const mods = getModulos();
    return Array.isArray(mods) && mods.includes(feature);
}

export function hasAnyFeature(...features) {
    return features.some((f) => hasFeature(f));
}

export function setModulos(modulos) {
    if (Array.isArray(modulos)) {
        localStorage.setItem('modulos', JSON.stringify(modulos));
    }
}

export function setPlanCodigo(codigo) {
    if (codigo) localStorage.setItem('planCodigo', String(codigo));
}

export function getPlanCodigo() {
    return localStorage.getItem('planCodigo') || 'legacy_full';
}

export const FEATURE_LABELS = {
    stock: 'Stock',
    menu_online: 'Menú online',
    carrito_online: 'Carrito online',
    pedido_mostrador: 'Pedido mostrador',
    caja: 'Caja',
    pos: 'POS',
    vendedores: 'Vendedores',
    clientes: 'Clientes',
    analiticas: 'Analíticas',
    publicaciones: 'Publicaciones',
    tickets: 'Tickets',
    mercadopago_pos: 'Mercado Pago POS',
    mesas: 'Gestión de mesas',
    /** Solo visible para admin al asignar overrides (no en landing/planes). */
    integracion_arca: 'Integración ARCA',
};
